import { useMemo } from "react";
import Grid from "@mui/material/Grid";
import { Pie } from "react-chartjs-2";
import Circle from "@mui/icons-material/Circle";
import { Box, Typography } from "@maysoft/common-component-react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

import Strings from "constants/strings";

import { IDataSeries } from ".";
import { NoDataIcon } from "components/DataNotFound";

ChartJS.register(ArcElement, Tooltip, Legend);

const PieChartStatistic = ({
    title,
    total,
    dataSeries,
}: {
    title: string
    total: number;
    dataSeries: IDataSeries[];
}) => {

    const dataFormat = useMemo(() => {
        let value: number[] = [];
        let color: string[] = [];
        for (const element of [...dataSeries || []]) {
            value.push(element.value);
            color.push(element.color);
        };
        return { value, color };
    }, [dataSeries]);

    const percentValue = (value: any, total: any) => {
        return Math.round((Number(value) / Number(total)) * 100) ? Math.round((Number(value) / Number(total)) * 100) : "0";
    };

    return (
        <Grid container padding={3}>
            <Grid item xs={12} sm={6} md={4}>
                <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}>
                    {(total === 0)
                        ? (
                            <Box sx={{
                                display: "flex",
                                alignItems: "center",
                                flexDirection: "column",
                                justifyContent: "center",
                                width: "200px !important",
                                height: "200px !important",
                                border: "1px solid #cdcdcd",
                                borderRadius: 250 / 2,
                            }}>
                                <NoDataIcon color="#7b809a" />
                                <Typography variant="button" color="secondary">
                                    {Strings.COMMON.NO_DATA}
                                </Typography>
                            </Box>
                        )
                        : (
                            <Box sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                maxWidth: "200px !important",
                                maxHeight: "200px !important",
                            }}>
                                <Pie
                                    data={{
                                        datasets: [{
                                            data: [...dataFormat.value || []],
                                            backgroundColor: [...dataFormat.color || []],
                                        }]
                                    }}
                                />
                            </Box>
                        )
                    }
                </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={8}>
                <Typography variant="h6">
                    {title}
                </Typography>
                <Box sx={{
                    mt: 2,
                    gap: 1.5,
                    display: "flex",
                    flexDirection: "column",
                }}>
                    {dataSeries.map((item, index) => (
                        <Box key={index} sx={{
                            gap: 2,
                            display: "flex",
                            minWidth: "200px",
                            alignItems: "center",
                            justifyContent: "space-between",
                        }}>
                            <Box sx={{
                                gap: 1.5,
                                display: "flex",
                                alignItems: "center",
                            }}>
                                <Circle htmlColor={item.color} width={32} height={32} />
                                <Typography variant="button">
                                    {`${item.textLabel}:`}
                                </Typography>
                            </Box>
                            <Typography variant="button">
                                {`${item.value} (${percentValue(item.value, total)}%)`}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </Grid>
        </Grid>
    );
};


export default PieChartStatistic;